import { IStore } from 'old-store/types';
import { createSelector } from 'reselect';
import { getAllProduct } from 'modules/ScrShopNew/store/slices/products/selectors';
import { mapCheckoutProducts } from 'modules/ScrShopNew/store/utils/checkout';
import { ICheckoutReducer } from './types';

export const getCheckoutStore = ({ checkout }: IStore) => checkout;

export const getCheckoutProducts = createSelector(
  [getCheckoutStore, getAllProduct],
  (checkout, allProducts) => mapCheckoutProducts(checkout.products, allProducts, checkout.currency)
);

export const getNumberOfCheckoutProducts = createSelector(getCheckoutProducts, (products) =>
  products.reduce((prev, product) => prev + product.quantity, 0)
);

export const getCheckoutProductByID = createSelector(
  getCheckoutProducts,
  (products) => (productID: string) => products.find((product) => product._id === productID)
);

export const getCheckoutIDSelector = createSelector(getCheckoutStore, ({ _id }) => _id);

export const getCheckoutImageSelector = (store: IStore) => (imageID: string, productID: string) => {
  const product = getCheckoutProductByID(store)(productID);
  const images = product?.images || [];

  return images.find((image) => image._image === imageID);
};

export const getCheckoutSummary = createSelector(
  getCheckoutStore,
  (checkout) => (checkout as ICheckoutReducer).checkoutSummary
);

export const getCheckoutSummaryProducts = createSelector(
  [getCheckoutSummary, getAllProduct, getCheckoutStore],
  (checkoutSummary, allProducts, checkout) =>
    mapCheckoutProducts(checkoutSummary.products, allProducts, checkout.currency)
);

export const getCheckoutSummaryCartIDSelector = createSelector(
  getCheckoutSummary,
  (checkoutSummary) => checkoutSummary._shoppingCart
);
